export default __webpack_public_path__ + "static/media/overview.eb8cd3ad.svg";